import { render, staticRenderFns } from "./SignUpVideoCourse.vue?vue&type=template&id=21b49914&scoped=true&"
import script from "./SignUpVideoCourse.vue?vue&type=script&lang=ts&"
export * from "./SignUpVideoCourse.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpVideoCourse.vue?vue&type=style&index=0&id=21b49914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b49914",
  null
  
)

export default component.exports